module.exports = __webpack_public_path__ + "static/DisabledTripPostponed-7bc14b4a0780ce32c9441501e1fa993d.png";